<template>
    <div class="content">
        <!-- 题目 -->
        <el-col v-show="heart.questionDto.typeCode != 777" :span="24" class="tiMu" align="left"><div class="disIn hybrid" v-viewer v-html="`${qid}、${heart.questionDto.question}`">{{`${qid}、${heart.questionDto.question}`}}</div></el-col>
        <!-- 单选题 -->
        <div v-if="heart.questionDto.typeCode == 10" class="contentBox" :style="{marginTop: topHeight}">
            <single-choice ref="typeCodeRef" :sonData="heart" @storeLocally="storeLocally" :allAnswer="allAnswer" keep-alive></single-choice>
        </div>
        <!-- 多选题 -->
        <div v-if="heart.questionDto.typeCode == 11" class="contentBox" :style="{marginTop: topHeight}">
            <multiple-choice ref="typeCodeRef" :sonData="heart" @storeLocally="storeLocally" :allAnswer="allAnswer" keep-alive></multiple-choice>
        </div>
        <!-- 判断题 -->
        <div v-if="heart.questionDto.typeCode == 12" class="contentBox" :style="{marginTop: topHeight}">
            <judgment-questions ref="typeCodeRef" :sonData="heart" @storeLocally="storeLocally" :allAnswer="allAnswer" keep-alive></judgment-questions>
        </div>
        <!-- 听音填写 -->
        <div v-if="heart.questionDto.typeCode == 20" class="contentBox" :style="{marginTop: topHeight}">
            <listen-write ref="typeCodeRef" :sonData="heart" @storeLocally="storeLocally" :allAnswer="allAnswer" keep-alive></listen-write>
        </div>
        <!-- 视唱 -->
        <div v-if="heart.questionDto.typeCode == 30" class="contentBox" :style="{marginTop: topHeight}">
            <sightsinging ref="typeCodeRef" :sonData="heart" @storeLocally="storeLocally" :allAnswer="allAnswer" keep-alive></sightsinging>
        </div>
        <!-- 视频直播 -->
        <div v-if="heart.questionDto.typeCode == 40" class="contentBox" :style="{marginTop: topHeight}">
            <text-topic ref="typeCodeRef" :sonData="heart" @storeLocally="storeLocally" :allAnswer="allAnswer" keep-alive></text-topic>
        </div>
        <!-- 填空题 -->
        <div v-if="heart.questionDto.typeCode == 50" class="contentBox" :style="{marginTop: topHeight}">
            <fill-blanks ref="typeCodeRef" :sonData="heart" @storeLocally="storeLocally" :allAnswer="allAnswer" keep-alive></fill-blanks>
        </div>
        <!-- 节奏题打谱 -->
        <div v-if="heart.questionDto.typeCode == 60" class="contentBox" :style="{marginTop: topHeight}">
            <rhythm-dp-choice ref="typeCodeRef" :sonData="heart" @storeLocally="storeLocally" :allAnswer="allAnswer" @come3Time="come3Time" keep-alive></rhythm-dp-choice>
        </div>
        <!-- 节奏题视唱 -->
        <div v-if="heart.questionDto.typeCode == 61" class="contentBox" :style="{marginTop: topHeight}">
            <rhythm-sc-choice ref="typeCodeRef" :sonData="heart" @storeLocally="storeLocally" :allAnswer="allAnswer" keep-alive></rhythm-sc-choice>
        </div>
        <!-- 绘画题 -->
        <div v-if="heart.questionDto.typeCode == 70" class="contentBox" :style="{marginTop: topHeight}">
            <painting-hh ref="typeCodeRef" :sonData="heart" @storeLocally="storeLocally" :allAnswer="allAnswer" keep-alive></painting-hh>
        </div>
        <!-- 连线题 90 -->
        <div v-if="heart.questionDto.typeCode == 90" class="contentBox" :style="{marginTop: topHeight}">
            <connection-line ref="typeCodeRef" :sonData="heart" :serial="serial" @storeLocally="storeLocally" :buttonNum="buttonNum" :allData="allData" :allAnswer="allAnswer" keep-alive></connection-line>
        </div>
        <!-- 连线题 91 -->
        <div v-if="heart.questionDto.typeCode == 91" class="contentBox" :style="{marginTop: topHeight}">
            <connection-line91 ref="typeCodeRef" :sonData="heart" :serial="serial" @storeLocally="storeLocally" :buttonNum="buttonNum" :allData="allData" :allAnswer="allAnswer" keep-alive></connection-line91>
        </div>
        <!-- 创意题 -->
        <div v-if="heart.questionDto.typeCode == 100" class="contentBox" :style="{marginTop: topHeight}">
            <creative-topic ref="typeCodeRef" :sonData="heart" :serial="serial" @storeLocally="storeLocally" :buttonNum="buttonNum" :allAnswer="allAnswer" keep-alive></creative-topic>
        </div>
        <!-- 视频题 -->
        <div v-if="heart.questionDto.typeCode == 110" class="contentBox" :style="{marginTop: topHeight}">
            <video-topic ref="typeCodeRef" :sonData="heart" :serial="serial" @storeLocally="storeLocally" :buttonNum="buttonNum" :allAnswer="allAnswer" :examMinTime="examMinTime" keep-alive></video-topic>
        </div>
        <!-- 文件题 -->
        <div v-if="heart.questionDto.typeCode == 120" class="contentBox" :style="{marginTop: topHeight}">
            <file-up-topic ref="typeCodeRef" :sonData="heart" :serial="serial" @storeLocally="storeLocally" :buttonNum="buttonNum" :allAnswer="allAnswer" :networkError="networkError" :upFileName120="upFileName120" keep-alive></file-up-topic>
        </div>
        <!-- 听音打谱 -->
        <div v-if="heart.questionDto.typeCode == 150" class="contentBox" :style="{marginTop: topHeight}">
            <clef-topic ref="typeCodeRef" :sonData="heart" :serial="serial" @storeLocally="storeLocally" :buttonNum="buttonNum" :allAnswer="allAnswer" keep-alive></clef-topic>
        </div>
        <!-- 拖拽题 -->
        <div v-if="heart.questionDto.typeCode == 170" class="contentBox" :style="{marginTop: topHeight}">
            <draggable-topic ref="typeCodeRef" :sonData="heart" :serial="serial" @storeLocally="storeLocally" :buttonNum="buttonNum" :allAnswer="allAnswer" keep-alive></draggable-topic>
        </div>
        <!-- 静态页面 -->
        <div v-if="heart.questionDto.typeCode == 777" class="contentBox">
            <!-- <grade-test1_1 v-if="heart.questionDto.location==0&&heart.questionDto.sslName==91" :buttonNum="buttonNum" :serial="serial"  keep-alive></grade-test1_1> -->
        </div>
    </div>
</template>
<script>
import rhythmDpChoice from '../../components/exam/rhythmDpChoice'
import rhythmScChoice from '../../components/exam/rhythmScChoice'
import singleChoice from '../../components/exam/singleChoice'
import multipleChoice from '../../components/exam/multipleChoice'
import judgmentQuestions from '../../components/exam/judgmentQuestions'
import listenWrite from '../../components/exam/listenWrite'
import fillBlanks from '../../components/exam/fillBlanks'
import sightsinging from '../../components/exam/sightsinging'
import paintingHh from '../../components/exam/paintingHh'
import textTopic from '../../components/exam/textTopic'
import connectionLine from '../../components/exam/connectionLine'
import connectionLine91 from '../../components/exam/connectionLine91'
import creativeTopic from '../../components/exam/creativeTopic'
import videoTopic from '../../components/exam/videoTopic'
import fileUpTopic from '../../components/exam/fileUpTopic'
import clefTopic from '../../components/exam/clefTopic'
import draggableTopic from '../../components/exam/draggableTopic'
import utils from '../../lib/util'
    export default {
        name:"topic",
        props: {
            questionText: Object,
            serial:Number,
            upFileName120:String,
            buttonNum:Number,
            allData:Object,
            allAnswer:Object,
            forced:Array,
            networkError:Boolean,
            examMinTime:Number,
            firstStartDateVal:String,
            uuid1:String,
        },
        data() {
            return {
                heart:{
                    questionDto:{
                        question:''
                    }
                },
                topHeight:'50px',
                qid:'',
                uid:this.$base64.decode(window.localStorage.getItem('uid-web')),
            }
        },
        components:{
            rhythmDpChoice,
            rhythmScChoice,
            singleChoice,
            multipleChoice,
            judgmentQuestions,
            listenWrite,
            fillBlanks,
            sightsinging,
            paintingHh,
            textTopic,
            connectionLine,
            connectionLine91,
            creativeTopic,
            videoTopic,
            fileUpTopic,
            clefTopic,
            draggableTopic,
        },
        watch: {},
        computed:{},
        created(){},
        mounted(){
            let that = this;
            that.$nextTick(function(){
                that.qid = this.serial
                that.process(that.questionText)
                setTimeout(function(){
                    if(that.heart.questionDto.typeCode != 777){
                        that.topHeight = window.getComputedStyle(document.getElementsByClassName('tiMu')[Number(that.serial - 1)]).height
                        that.topHeight = (Number(that.topHeight.replace('px',''))+5)+'px'
                    }
                },100)

                let nowNum = []
                that.forced.some(item=>{
                    if(that.allData.name&&(that.allData.name.trim()==item.name.trim()||that.allData.name.trim()==item.name.trim())){
                        item.insertAdd.forEach((elem, index) => {
                            nowNum.push(elem+1)
                        })
                        if(nowNum.indexOf(that.serial)==-1){
                            let s_ing = utils.mottoClone(that.serial)
                            let nc = 1;
                            that.meReduction(nowNum,s_ing,nc,(s,nc)=>{
                                that.qid = `(${nc})`
                            })
                        }
                        return true;
                    }
                })
            })
        },
        methods:{
            meReduction(nowNum,s,nc,callback){
                s--;
                if(nowNum.indexOf(s)==-1){
                   nc++;
                   this.meReduction(nowNum,s,nc,callback) 
                }else{
                   callback(s,nc)
                }
            },

            process(val){
                this.heart = utils.deepClone2(val)
                // 删除分值前的回车符
                let que = this.heart.questionDto.question
                let b = que.split('","element"')[0]
                let w = que.indexOf('","element"')
                if(que.charAt(w-2)+que.charAt(w-1)=='\\n')
                this.heart.questionDto.question = que.substring(0,w-2)+que.substring(w,que.length)
                // END
                this.heart.questionDto.question = utils.dealText(this.heart.questionDto.question.replace(/\\n/g,'<br>'))
            },

            /**
             * 判断是否已答题
             * return：Boolean
             */
            whetherAnswer(){
                return this.$refs.typeCodeRef.yesNotProblem()
            },

            // 切换下一题结束音频
            endAudio(){
                return this.$refs.typeCodeRef.endAudio()
            },

            // 本地存储
            storeLocally(){
                this.$emit('storeLocally')
            },

            // 获取播放次数 
            getPlayss(){
                return this.$refs.typeCodeRef!=undefined? this.$refs.typeCodeRef.plays:''
            },

            // 获取提交次数 
            getSubmitNum(){
                return this.$refs.typeCodeRef!=undefined? this.$refs.typeCodeRef.submitNum:''
            },

            // 放弃答题
            editAnswerType(val){
                return this.$refs.typeCodeRef.changeAnswerType(val)
            },

            // 3秒倒计时
            come3Time(){
                this.$emit('come3Time')
            },

            // 处理提交数据
            processTheData(){
                let that = this
                // paperQuestionId:试卷问题id
                // questionId:题目 id
                // questionVer:题目 版本
                // score:题目得分
                // selectIds:选择题选择的id 逗号分隔 例如 1,3,4
                // singAudioUrl:视唱题 音频url
                // textVideoUrl:文字题 视频url
                // writeImgUrl:听音填写题 图片url
                // rhythmBeatVal:rhythmBeatVal节奏题打谱 数据
                // rhythmSingAudioUrl:rhythmSingAudioUrl节奏题 音频url
                // fillBlankVal:fillBlankVal填空题答案 #@# #@#1#@# 分隔
                // drawImgUrl:绘画题url
                // lineIds连线题答案[id逗号分隔]
                // connectVal 91连线题json
                // detailJsonVal:得分细节
                // originalityVal:创意题文字
                // viewVal视频题答题文字
                // designUrl 文件题zip路径
                // answerType: 答题状态 null=答题/跳过 1=放弃答题"
                // beatVal 150乐谱数据
                // beatImgUrl 150乐谱数据图片
                // dragVal 170拖拽题数据

                let loc = localStorage.getItem('ceping-'+that.uid+'-'+that.allData.bId)? JSON.parse(localStorage.getItem('ceping-'+that.uid+'-'+that.allData.bId)):''
                let ls = loc? loc.dataList[this.serial-1]? loc.dataList[this.serial-1].obj.lineIds:'':''
                let Cs = loc? loc.dataList[this.serial-1]? loc.dataList[this.serial-1].obj.connectVal:'':''
                let param = {
                    paperQuestionId:that.heart.bId,
                    questionId:that.heart.questionId,
                    questionVer:that.heart.questionVer,
                    questionType:that.heart.questionDto.typeCode,
                    answerType:that.$refs.typeCodeRef? that.$refs.typeCodeRef.answerType? that.$refs.typeCodeRef.answerType:null:'',
                    score:that.$refs.typeCodeRef? String(that.$refs.typeCodeRef.score).length>0? that.$refs.typeCodeRef.score:'':'',
                    selectIds:that.$refs.typeCodeRef? that.$refs.typeCodeRef.sonData.questionDto.typeCode==11? that.$refs.typeCodeRef.double_advancedRadio:that.$refs.typeCodeRef.advancedRadio:'',
                    singAudioUrl:that.$refs.typeCodeRef? that.$refs.typeCodeRef.singingluYingUrl? that.$refs.typeCodeRef.singingluYingUrl:'':'',
                    textVideoUrl:that.$refs.typeCodeRef? that.$refs.typeCodeRef.textVideoUrl? that.$refs.typeCodeRef.textVideoUrl:'':'',
                    writeImgUrl:that.$refs.typeCodeRef? that.$refs.typeCodeRef.updataImgUrl? that.$refs.typeCodeRef.updataImgUrl:'':'',
                    rhythmBeatVal:that.$refs.typeCodeRef? that.$refs.typeCodeRef.rhythmBeatVal? that.chuliDP(that.$refs.typeCodeRef.rhythmBeatVal):'':'',
                    rhythmSingAudioUrl:that.$refs.typeCodeRef? that.$refs.typeCodeRef.luYingUrl? that.$refs.typeCodeRef.luYingUrl:'':'',
                    fillBlankVal:that.$refs.typeCodeRef? that.$refs.typeCodeRef.valueComple? that.$refs.typeCodeRef.valueComple:'':'',
                    drawImgUrl:that.$refs.typeCodeRef? that.$refs.typeCodeRef.drawImgUrl? that.$refs.typeCodeRef.drawImgUrl:'':'',
                    detailJsonVal:that.$refs.typeCodeRef? that.$refs.typeCodeRef.detailJsonVal? that.$refs.typeCodeRef.detailJsonVal:'':'',
                    rhythmBeatAudioUrl:that.$refs.typeCodeRef? that.$refs.typeCodeRef.rhythmBeatAudioUrl? that.$refs.typeCodeRef.rhythmBeatAudioUrl:'':'',
                    lineIds:that.$refs.typeCodeRef? that.$refs.typeCodeRef.lineIds? that.$refs.typeCodeRef.lineIds=='0'?'':that.$refs.typeCodeRef.lineIds:ls:'',
                    connectVal:that.$refs.typeCodeRef? that.$refs.typeCodeRef.connectVal? that.$refs.typeCodeRef.connectVal=='0'?'':that.$refs.typeCodeRef.connectVal:Cs:'',
                    originalityVal:that.$refs.typeCodeRef? that.$refs.typeCodeRef.originalityVal? that.$refs.typeCodeRef.originalityVal:'':'',
                    viewVal:that.$refs.typeCodeRef? that.$refs.typeCodeRef.viewVal? that.$refs.typeCodeRef.viewVal:'':'',
                    designUrl:that.$refs.typeCodeRef? that.$refs.typeCodeRef.designUrl? that.$refs.typeCodeRef.designUrl:'':'',
                    beatVal:that.$refs.typeCodeRef? that.$refs.typeCodeRef.beatVal? that.$refs.typeCodeRef.beatVal:'':'',
                    beatImgUrl:that.$refs.typeCodeRef? that.$refs.typeCodeRef.beatImgUrl? that.$refs.typeCodeRef.beatImgUrl:'':'',
                    dragVal:that.$refs.typeCodeRef? that.$refs.typeCodeRef.dragVal? that.$refs.typeCodeRef.dragVal:'':'',
                }
                return param
            },
            chuliDP(val){
                let listNames = utils.deepClone2(val)
                for (let i = 0; i < listNames.length; i++) {
                    if(String(listNames[i]).length>=13){
                        listNames.splice(listNames.indexOf(listNames[i]),1);
                    }
                }
                return listNames.join()
            }
        }
    }
</script>
<style scoped lang="less">
    .content{
        height: 100%;
        width: 100%;
        position: relative;
    }
    .tiMu{
        display: block;
        position: absolute;
        top: 0;
        height: auto;
        width: 100%;
        margin-bottom: 5px;
        box-sizing: border-box;
        padding: 13px 20px;
        // font-weight: bold;
        background: #1E4BB0;
        border-radius: 5px;
        color: #fff;
    }
    .audioCom{
        display: inline-block;
        vertical-align: bottom;
    }
    .playNum{
        display: inline-block;
        width: 48px;
        padding-top: 5px;
        text-align: right;
        position: relative;
        margin-left: 15px;
        .playNumIng{
            position: absolute;
            top: 14%;
            bottom: 5%;
            left: 0;
            img{
                height: 100%;
            }
        }
    }
    .contentBox{
        margin-top: 0px;
        position: absolute;
        top: 0%;
        bottom: 0;
        width: 100%;
        
    }
</style>
<style>
    .disIn{float:left;width: 100%;}
    .hybrid .tableimg{
        height: 50px;
        width: 90px;
        position: relative;
        display: inline-block;
        vertical-align: middle;
    }
    .hybrid .tableimg .view{
        height: 50px;
        width: 90px;
    }
    .hybrid .tableimg img{
        max-width: 100%;
        max-height: 100%;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        display: block;
        margin: auto auto;
    }
    .hybrid video{
        width: 130px;
        height: 100px;
        outline: none;
    }   
    .hybrid audio{
        width: 250px;
        height: 35px;
        outline: none;
        display: block;
    }
    @media screen and (min-height: 900px) {
        .disIn{
            max-height: 280px;
            overflow-y: auto;
        }
    }
    @media screen and (max-height: 900px) {
        .disIn{
            max-height: 235px;
            overflow-y: auto;
        }
    }
    @media screen and (max-height: 800px) {
        .disIn{
            max-height: 200px;
            overflow-y: auto;
        }
    }
    @media screen and (max-height: 700px) {
        .disIn{
            max-height: 130px !important;
            overflow-y: auto !important;
        }
    }

    /* 滚动条样式 */
    .tiMu ::-webkit-scrollbar 
    { 
        width: 5px; 
    }
    
    /*定义滚动条轨道 内阴影+圆角*/
    .tiMu ::-webkit-scrollbar-track 
    { 
        border-radius: 10px; 
        background-color: #00174E; 
    } 
    
    /*定义滑块 内阴影+圆角*/
    .tiMu ::-webkit-scrollbar-thumb 
    { 
        border-radius: 10px; 
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3); 
        background-color: #B4B4B4;
    } 
</style>



// WEBPACK FOOTER //
// src/components/exam/topic.vue